 // components/Contact.jsx
import React, { useState } from 'react';
import './Contact.css';
import emailjs from 'emailjs-com';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FaLinkedin, FaGithub, FaWhatsapp } from 'react-icons/fa';

export default function Contact() {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.send(
      'service_3trwvbb',      // e.g., service_abc123
      'template_k2pia3q',     // e.g., template_xyz456
      formData,
      '2eGbZPRfTYAofHd-B'       // e.g., KkXzGAbCdEfGHiJk
    )
    .then(() => {
      toast.success('Message sent successfully ✅');
      setFormData({ name: '', email: '', message: '' });
    })
    .catch(() => {
      toast.error('Message failed to send ❌');
    });
  };

  return (
    <section className="glass" id="contact">
      <h2>Contact Me</h2>

      <div className="contact-content">
        <div className="contact-info">
          <p><strong>Email:</strong> tejapraveen2003@gmail.com</p>
          <p><strong>Phone:</strong> +91 7981715576</p>
          <p><strong>Location:</strong> Andhra Pradesh, India</p>
          <div className="contact-icons">
            <a href="https://www.linkedin.com/in/obulasetty-teja-praveen-deva-raju-39a669259" target="_blank" rel="noreferrer">
              <FaLinkedin />
            </a>
            <a href="https://github.com/TEJAPRAVEENDEVARAJU" target="_blank" rel="noreferrer">
              <FaGithub />
            </a>
            <a href="https://wa.me/917981715576" target="_blank" rel="noreferrer">
              <FaWhatsapp />
            </a>
          </div>
        </div>

        <form className="contact-form" onSubmit={sendEmail}>
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            required
            value={formData.name}
            onChange={handleChange}
          />
          <input
            type="email"
            name="email"
            placeholder="Your Email"
            required
            value={formData.email}
            onChange={handleChange}
          />
          <textarea
            name="message"
            placeholder="Your Message"
            rows="5"
            required
            value={formData.message}
            onChange={handleChange}
          ></textarea>
          <button type="submit">Send Message</button>
        </form>
      </div>

      <ToastContainer position="top-right" />
    </section>
  );
}
